/* import __COLOCATED_TEMPLATE__ from './locked-article-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();